import { useSearchOS } from "./useSearchOS";

//components
import { BreadCrumbs, Button } from "@atoms";
import { DataOS } from "@organisms";
import { Input } from "@molecules";
import { ConfirmData } from "./ConfirmData";

export const SearchOS = () => {
  const helper = useSearchOS();

  if (helper.loading) {
    return <p>carregando...</p>;
  }

  if (helper.confirm && helper.osSaved && helper.osSearched) {
    return (
      <ConfirmData
        os={helper.osSaved}
        backPage={helper.backToSearchPage}
        handleCreate={helper.handleCreateTicket}
        mainTicket={helper.mainTicket}
        loading={helper.loading}
        macro={helper.macro ?? ""}
      />
    );
  }

  return (
    <div>
      <BreadCrumbs items={["OS", "Consulta"]} />
      <div
        className="w-full max-h-[65vh] overflow-y-auto overflow-x-hidden
             -ms-overflow-style-none
             scrollbar-none"
      >
        <div className="w-[97%] ml-[5px] h-[65vh]">
          <Input
            label="Consultar OS"
            type="string"
            placeholder="Buscar por OS, n. de série ou CPF"
            onValueChange={(e) => {
              helper.handleInputChange(e.trim());
            }}
          />
          <br />

          {helper.osSearched && !helper.loading && (
            <DataOS
              ServiceOrder={helper.osSearched}
              goToInteractions={helper.handleShowInteractions}
              saveOs={helper.saveOs}
              goToConfirm={helper.goToConfirm}
              showInteractions={helper.showInteractions}
              backToSearchPage={helper.backToSearchPage}
            />
          )}
        </div>
      </div>
      {!helper.showInteractions && (
        <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px] bg-white">
          <Button onClick={helper.handleSearch}>Buscar</Button>
          <Button
            onClick={() => {
              helper.backPage(-1);
            }}
          >
            Voltar
          </Button>
        </div>
      )}
    </div>
  );
};
